<template>
  <Teleport to='body'>
    <hr class='veil' />
    <main class='event'>
      <Close @click='$router.back()'/>
      <header>
        <h5 v-html='humanDaysToGo(kql.page?.content.date)'/>
        <h2 v-if='kql.page?.content.date' v-html='prettyDate(kql.page?.content.date)'/>
        <h3 v-if='kql.page?.content.date && location'>
          <span v-html='location?.city' /><template v-if='location?.country'>,<br />
          <em v-html='location?.country' /></template>
        </h3>
        <h3 class='orchestra' v-html='kql.page?.content.title'/>
      </header>
      <div class="event-details">
        <section v-html='kql.page?.content.programme' />
        <br/>
        <br/>
        <h5>Artists</h5>
        <div class="artists" v-html='kql.page?.content.artist' />
        <br/>
        <br/>
        <br/>
        <ReadMore :url='kql.page?.content.moreinfo' />
      </div>
    </main>
  </Teleport>
</template>

<script setup>
  import { resolveLocation, pathName } from '@/utils';
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';
  import timezone from 'dayjs/plugin/timezone';
  import { useStore } from '../KQL.js';
  import { routeStore } from '@/utils';

  // Configure Day.js with timezone support
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const kql = useStore();
  const location = computed(()=>resolveLocation(kql.page?.content));
  const prettyDate = (date)=>dayjs(date).format('MMMM D');
  // Compare dates at the calendar day level in user's local timezone
  const daysFromToday = (date) => dayjs(date).startOf('day').diff(dayjs().startOf('day'), 'day');
  const humanDaysToGo = (date) => daysFromToday(date) > 0 ? `IN ${daysFromToday(date)} DAYS` : daysFromToday(date) === 0 ? 'TODAY' : `${Math.abs(daysFromToday(date))} DAYS AGO`;
  const previousURL = routeStore().visitedURLs[1] ? routeStore().visitedURLs[1] : '/';
</script>

<style scoped>
  @import '@/css/breakpoints.css';

  svg.close {
    position: fixed;
    stroke: var(--light);
    width: 2rem;
    top: var(--offset);
    right: var(--offset);
    cursor: pointer;
  }

  hr {
    position: fixed;
    backdrop-filter: blur(10px);
    border: none;
    top: 0 !important;
    left: 0;
    right: 0;
    bottom: 0;
    vertical-align: mathematical;
    padding: 0;
    margin: 0;
    z-index: 998 !important;
  }

  main.event {
    z-index: 999 !important;
    position: absolute !important;
    top: 0 !important;
    left: 0;
    right: 0;
    min-height: 60vh;
  }

  main {
    display: flex;
    max-width: 30rem;
    margin: auto;
    flex-direction: column;
    justify-content: center;
    padding-top: 15rem;
  }

  @media (--phone) {
    main {
      flex-direction: column;
    }
  }

  a {
    --darker: var(--gray);
    margin-bottom: 9rem;
  }

  a:hover {
    --darker: var(--light);

  }

  h2 {
    font-size: 5.5rem;
    line-height: 1em;
    margin-bottom: 1.5rem;
  }

  h3 {
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }

  h3 em {
    white-space: nowrap;
    overflow: hidden;
  }

  h3.orchestra {
    max-width: 10em;
  }

  h4 {
    text-transform: uppercase;
  }

  h6 {
    text-transform: uppercase;
  }

  h5 {
    color: var(--gray);
  }

  .event-details {
    color: var(--lightgray);
  }

  .event-details .artists :deep(li) {
    color: var(--gray);
    letter-spacing: 0.05em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.2rem;
    letter-spacing: 0.0em;
  }

  .event-details :deep(ul) {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .event-details :deep(section li) {
    padding: 0;
    margin: 0;
    list-style: none;
    font-family: var(--serif);
    font-size: 3rem;
    font-style: italic;
    line-height: 0.9em;
    max-width: 8em;
    font-weight: 200;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .event-details :deep(section li strong) {
    font-size: 1.2rem;
    letter-spacing: 0.05em;
    font-family: var(--sans);
    text-transform: uppercase;
    display: block;
    padding: 0;
    margin: 0;
    margin-top: 1em;
    margin-bottom: -0.5em;
    list-style: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

  }

  .event-details :deep(li u), .event-details :deep(li a) {
    text-decoration: none;
  }


</style>
